import React, { useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';

import { input } from '$gbusiness/helpers';
import { FormSection } from '$gcomponents/reusables';
import { Button, Text } from '$gcomponents/primitives';

import { TARIFF_FORM } from './tariffForm';
import TariffModel from '$fbusiness/models/tariff';
import { AppForm } from '$styles/general';
import MuiModal from '$gcomponents/reusables/modal/material';
import intl from '$intl';
import { factoryActions } from '$fbusiness/redux/factory';
import { AppModel } from '$business/redux/';
import { configs } from '$configs';

interface TariffModalScreenProps {
  tariff: TariffModel;
  onClose: Function;
}

const TariffModalScreen: React.FC<TariffModalScreenProps> = ({ tariff, onClose }) => {
  const dispatch = useDispatch();
  const isFinished = useSelector((state: AppModel) => state.factory.isFinished);
  const formRef = useRef<any>();

  useEffect(() => {
    if (!isFinished) return;

    dispatch(factoryActions.resetFinished());
    onClose();
  }, [isFinished, onClose, dispatch]);

  if (!tariff) return null;
  const { id, ...initialValues } = tariff;

  const onSubmit = (values) => {
    dispatch(factoryActions.saveObj(id || 0, values, configs.api.tariff, factoryActions.fetchTariffs));
  };

  const validateForm = (values) => input.validateError(TARIFF_FORM, values);

  return (
    <Formik
      innerRef={formRef}
      enableReinitialize={true}
      initialValues={initialValues}
      validate={validateForm}
      onSubmit={(values) => {
        onSubmit(values);
      }}>
      {(formik) => (
        <MuiModal
          open={!!tariff}
          width="400px"
          onClose={() => onClose()}
          title={intl('SCREEN.TARIFF.TITLE')}
          footer={
            <Button fullWidth onClick={formik.handleSubmit} disabled={!(formik.isValid && formik.dirty)}>
              <Text k="BUTTON.SAVE" />
            </Button>
          }>
          <div className="content">
            <AppForm>
              <FormSection FORM={TARIFF_FORM} formik={formik} />
            </AppForm>
          </div>
        </MuiModal>
      )}
    </Formik>
  );
};

export default TariffModalScreen;
